module.exports = __webpack_public_path__ + "img/1474479335.3f6a5587.jpg";